import backend from '@common/backend';

const BASE = '/notifications';

export interface IGetNotificationsQuery {
	page?: number;
	limit?: number;
	service_id?: string | number;
	is_modal?: 0 | 1;
}

export const getNotifications = async (query?: IGetNotificationsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const readNotification = async (id: number, status: string) =>
	backend.patch(`${BASE}/${id}/update-status`, {
		status,
	});

export const readAllNotification = async (status: string) =>
	backend.post(`${BASE}/read-all`, {
		status,
	});

type PushTokenPayload = PushSubscriptionJSON;

export const sendToken = async (payload: PushTokenPayload) =>
	backend.post('/fcm-tokens', {
		token: payload,
	});

export const sendTestPush = async () => backend.post('/fcm-tokens/send-test', {});

export const sendTestPushForAll = async () =>
	backend.post('/fcm-tokens/send-test?send_to_all=1', {});

export const getCounter = async (query: { service_id?: string | number } = {}) =>
	backend.get(`${BASE}/count`, {
		params: query,
	});
